import { Children, ReactNode } from 'react';
import {
  PageOwnerAvatar,
  PageOwnerAvatarProps,
} from '../PageOwnerAvatar/PageOwnerAvatar';

import { DefaultAvatar } from '../DefaultAvatar/DefaultAvatar';
import React from 'react';
import classNames from 'classnames';
import { colors } from '@justgiving/carepack-design-tokens';
import styles from './AvatarGroup.module.scss';

type AvatarGroupProps = {
  max: number;
  children: ReactNode;
  totalCount?: number;
  as?: React.ElementType;
  className?: string;
  onClick?: (event: MouseEvent) => void;
  ariaLabel?: string | null;
  isDisabled?: boolean;
  avatarSize?: PageOwnerAvatarProps['size'];
};

export const AvatarGroup = ({
  children,
  max,
  totalCount,
  as = 'div',
  className,
  onClick,
  ariaLabel,
  isDisabled,
  avatarSize,
}: AvatarGroupProps) => {
  const Element = as;
  const childrenCount = totalCount ?? Children.count(children);
  const displayChildren = Children.toArray(children).slice(0, max);
  const remaining = childrenCount - max;

  return (
    <Element
      className={classNames(styles.avatarGroup, className)}
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={isDisabled}
    >
      {displayChildren.map((c) =>
        React.isValidElement<PageOwnerAvatarProps>(c)
          ? React.cloneElement<PageOwnerAvatarProps>(c, { size: avatarSize })
          : null,
      )}
      {childrenCount > max ? (
        <DefaultAvatar
          fillColor={colors.colorNeutral600}
          className={styles.defaultAvatar}
          textColor={colors.colorGrey400}
          size={avatarSize}
        >
          +{remaining}
        </DefaultAvatar>
      ) : null}
    </Element>
  );
};

const Avatar = ({ className, ...props }: PageOwnerAvatarProps) => (
  <PageOwnerAvatar className={classNames(styles.avatarItem)} {...props} />
);

AvatarGroup.Avatar = Avatar;
